import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import ContactCard from '../ContactCard/ContactCard';
import { dateFormatLong } from '../../helpers/formats';
import classes from './Comment.scss';

export const Comment = props => {
  if (
    typeof props.comment.body === 'undefined' ||
    props.comment.body.length === 0
  ) {
    return null;
  }

  const date = moment(props.comment.created_at).format(dateFormatLong);

  let contactCard = null;
  let name = 'unbekannt';

  if (props.comment.user) {
    contactCard = (
      <ContactCard
        name={props.comment.user.name}
        key={`contactcard_comment_${props.comment.id}`}
        type="staff"
        displayType="imageOnly"
        id={props.comment.user.id}
      />
    );

    name = <span className={classes.name}>{props.comment.user.name}</span>;
  }

  let textClasses = null;
  if (
    typeof props.comment.body !== 'undefined' &&
    /[^\u0000-\u00ff]/.test(props.comment.body.trim()) === true &&
    (props.comment.body.trim().length === 2 ||
      props.comment.body.trim().length === 4)
  ) {
    textClasses = classes.onlyEmoji;
  }

  return (
    <div className={classes.comment}>
      <div className={classes.contact}>{contactCard}</div>
      <div className={classes.body}>
        <p className={textClasses}>{props.comment.body}</p>
        <span className={classes.date}>
          {name} · {date}
        </span>
      </div>
    </div>
  );
};
Comment.propTypes = {
  comment: PropTypes.object.isRequired,
};
export default Comment;



// WEBPACK FOOTER //
// ./src/components/Comment/Comment.js